const getDriverIsLoading = (state) => state.driver.isLoading;
const getDriverErrors = (state) => state.driver.errors;
const getDriverActiveStep = (state) => state.driver.activeStep;
const getDriverData = (state) => state.driver.driverData;
const getDriverDocuments = (state) => state.driver.documentsData;

export { getDriverIsLoading, getDriverErrors, getDriverActiveStep, getDriverData, getDriverDocuments };
